import { IconButton, TextField } from "@mui/material";
import Icon from "@mui/material/Icon";

import { DrawerFormAddButton, DrawerFormRow, DrawerFormSection } from "../../../../components/DrawerForm";
import { FormHiddenField } from "../../../../components/forms";

type StringListFieldProps = {
  label: string;
  values: string[];
  onChange: (values: string[]) => void;
  fieldName: string;
  placeholder?: string;
};

const StringListField = ({
  label,
  values,
  onChange,
  fieldName,
  placeholder = "Value",
}: StringListFieldProps) => {
  const addValue = () => onChange([...values, ""]);
  const removeValue = (index: number) => onChange(values.filter((_, i) => i !== index));
  const updateValue = (index: number, value: string) =>
    onChange(values.map((entry, i) => (i === index ? value : entry)));

  return (
    <DrawerFormSection title={label} action={<DrawerFormAddButton onClick={addValue} />}>
      {values.map((value, index) => (
        <DrawerFormRow key={index}>
          <TextField
            fullWidth
            size="small"
            placeholder={placeholder}
            value={value}
            onChange={(event) => updateValue(index, event.target.value)}
          />
          <IconButton size="small" onClick={() => removeValue(index)} color="error" aria-label={`Remove ${label}`}>
            <Icon>remove</Icon>
          </IconButton>
        </DrawerFormRow>
      ))}
      <FormHiddenField
        name={fieldName}
        value={JSON.stringify(values.map((entry) => entry.trim()).filter(Boolean))}
      />
    </DrawerFormSection>
  );
};

export default StringListField;
